import React, { useEffect, useState } from 'react';

import useAsync from '../hooks/useAsync';
import useModal from '../hooks/useModal';
import usePrevious from '../hooks/usePrevious';

import { FormRow } from '../components/Form/tailwindForm';
import Button from '../components/Button';
import { AttributeRow } from '../components/Attributes/Attributes_old';
import SelectAsset from '../components/SelectAsset';
import Modal from '../components/Shell/Modal';

import { addTicket, getAssets } from '../api';

const AddTicketSlider = () => {
	const { open, setClose } = useModal('addTicket');
	const [form, setForm] = useState({});

	const {
		execute: onAdd,
		status,
		error,
		resetError,
	} = useAsync(addTicket, {
		immediate: false,
	});

	const { value: items, execute: refreshAssets } = useAsync(getAssets, {
		immediate: false,
	});

	const prevOpen = usePrevious(open);

	useEffect(() => {
		if (open) {
			refreshAssets();
		} else if (!open && prevOpen) {
			setForm({});
			resetError();
		} else {
			resetError();
		}
	}, [open]);

	const hasError = status === 'error';
	const isLoading = status === 'pending';
	return (
		<Modal
			name={'addTicket'}
			title="Create a Ticket"
			onClose={() => setClose()}
			zIndex={122}
		>
			{hasError ? (
				<div
					className="p-4 mb-4 text-xs text-red-700 bg-red-100 rounded-lg"
					role="alert"
				>
					<span className="font-medium">Uh oh, </span>something went wrong
				</div>
			) : null}

			<div className="grid gap-y-4">
				<AttributeRow name="Select an asset" isEditing={true} required={true}>
					<SelectAsset
						onChange={(value) => setForm({ ...form, assetId: value?.id })}
						value={form?.assetId}
					/>
				</AttributeRow>

				<textarea></textarea>
			</div>

			<FormRow className="pt-4" alignRight>
				<Button onClick={() => onAdd(configurePayload(form), () => setClose())}>
					{isLoading ? 'Creating...' : 'Create ticket'}
				</Button>
			</FormRow>
		</Modal>
	);
};

const configurePayload = ({ assetId, summary, description } = {}) => ({
	assetId,
	summary,
	description,
	type: 'asset',
});

export default AddTicketSlider;
